/** Name + de-emphasized code split out of a flat `code | name` identifier. */
export interface IdentifierParts {
	/** Primary, lead-with text (the human name). */
	name: string;
	/** Muted secondary code, or `null` when the value carries no `code | name` split. */
	code: string | null;
}

const SEP = " | ";

/**
 * Split a flat label-identifier of the form `CODE | NAME` (the `displayName`
 * convention, e.g. `N-100062 | Crossroads`, `#2019-6109 | Guadalupe …`) into
 * a name-leading primary + a muted code. The renderer leads with `name` and
 * demotes `code` so the table reads by name, not by opaque note number.
 *
 * Without the separator the whole value is the name and `code` is `null`.
 */
export function splitIdentifierLabel(value: string): IdentifierParts {
	const idx = value.indexOf(SEP);
	if (idx === -1) return { name: value, code: null };
	return { name: value.slice(idx + SEP.length), code: value.slice(0, idx) };
}
